import { useTranslation } from 'react-i18next'
import { TopWrapper, TotalMails, TotalMailsMobile } from './styles'
import { MailIcon } from 'components/Icons'

interface IProps {
  totalCount?: number,
}

const Topbar = (props: IProps) => {
  const { totalCount } = props
  const { t } = useTranslation()

  return (
    <TopWrapper>
      <TotalMails>
        <MailIcon />
        <span>{t('global.total')}</span>&nbsp;:&nbsp;
        { totalCount === undefined && <>chargement...</> }
        { totalCount !== undefined && <>{totalCount}&nbsp;{t('global.mail' + (totalCount > 1 ? 's' : ''))}</> }
      </TotalMails>
      <TotalMailsMobile>
        {totalCount}
        <MailIcon />
      </TotalMailsMobile>
    </TopWrapper>
  )
}

export default Topbar
